import React from 'react'
import { GridColDef } from '@mui/x-data-grid'
import { GridItem } from '../gridItems'
import { ISubmitter } from '../../../../domain/interfaces/ISubmission'
import { dateToMMMDYYYY, dateToMMMDYYYYHHMMA } from '../../../../core/core'
import { submission } from '@formio/react'

export const submitter_columns: GridColDef[] = [
  {
    field: 'name',
    renderHeader: () => <GridItem text={'Submitter Name'} />,
    flex: 1,
    renderCell: ({ row }) => <GridItem text={row.name} />,
  },
  {
    field: 'createdAt',
    renderHeader: () => <GridItem text={'Date Submitted'} />,
    width: 200,
    renderCell: ({ row }) => <GridItem text={dateToMMMDYYYYHHMMA(row.createdAt)} />,
  },
]

export const normalizeSubmittersForDataGrid: any = (submitters: ISubmitter[] = []) => {
  return submitters
    .filter(s => s.submissionId)
    .map((submitter: any) => {
      return {
        id: submitter.id,
        submissionId: submitter.submissionId ? submitter.submissionId : 'no submission',
        name: submitter.name,
        createdAt: submitter.createdAt,
      }
    })
}
